module.exports = __webpack_public_path__ + "img/shopee.3532de9d.svg";